var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "record-viewer",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.$_.noop.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "a-tabs",
        {
          staticClass: "record-viewer-tab-container",
          attrs: { "default-active-key": _vm.defaultOpenTab || "record" },
        },
        [
          _c(
            "a-tab-pane",
            { key: "record", attrs: { tab: _vm.$t("modules.recordDetail") } },
            [
              _c(
                "a-spin",
                {
                  staticClass: "record-spin-container",
                  attrs: { spinning: _vm.loading, size: "large" },
                },
                [
                  _vm.table && _vm.record
                    ? _c("div", { staticClass: "record-container" }, [
                        _c(
                          "div",
                          { staticClass: "field-grid" },
                          _vm._l(_vm.table.fields, function (field) {
                            return _c(
                              "div",
                              { key: field._id, staticClass: "field-item" },
                              [
                                _c(
                                  "label",
                                  { staticClass: "field-label" },
                                  [
                                    _c("FieldIcon", {
                                      staticClass: "field-icon",
                                      attrs: {
                                        type: field.fieldType,
                                        "default-icon": field.icon,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(field.name))]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.record
                                  ? _c(_vm.getCellComponent(field.fieldType), {
                                      tag: "component",
                                      staticStyle: { "min-height": "28px" },
                                      attrs: {
                                        field: field,
                                        record: _vm.record,
                                        outlined: "",
                                        readonly: _vm.isReadOnlyField(
                                          field.fieldType
                                        ),
                                        table: _vm.table,
                                        tableId: _vm.table._id,
                                      },
                                      on: {
                                        "update-record": _vm.handleRecordUpdate,
                                        "view-conversation": function ($event) {
                                          return _vm.openConversationHistory(
                                            $event
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ])
                    : _c("div", { staticClass: "empty-info" }, [
                        _vm._v(_vm._s(_vm.$t("modules.recordNotFound"))),
                      ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            {
              key: "related-lists",
              attrs: { tab: _vm.$t("modules.relatedLists") },
            },
            [
              _vm.record
                ? _c("ModuleRelatedList", {
                    attrs: {
                      tableId: _vm.tableId,
                      recordId: _vm.recordId,
                      record: _vm.record,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "comments", attrs: { tab: _vm.commentTabTitle } },
            [
              _vm.record
                ? _c("RecordComments", {
                    attrs: { recordId: _vm.recordId },
                    on: { "comments-loaded": _vm.handleCommentsLoaded },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "tasks", attrs: { tab: _vm.$t("calendar.tasks") } },
            [_c("TableTask", { attrs: { recordId: _vm.recordId } })],
            1
          ),
          _vm._v(" "),
          _vm.isSupsisLeadTable()
            ? _c("a-tab-pane", { key: "crm", attrs: { tab: "CRM" } }, [
                _c("div", { staticClass: "crm-container" }, [
                  _c("iframe", {
                    staticClass: "crm-iframe",
                    attrs: {
                      src:
                        "https://crm.supsis.ai/dashboard/leads/" +
                        _vm.recordId +
                        "/tab/timeline?token=" +
                        _vm.token(),
                      width: "100%",
                      height: "600px",
                      frameborder: "0",
                    },
                  }),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showConversationHistory && _vm.activeConversation
        ? _c("UserChatHistoryWidget", {
            attrs: {
              "visitor-id": _vm.activeConversation.visitor,
              "conversation-id": _vm.activeConversation._id,
            },
            on: { close: _vm.closeConversationHistory },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }